import { Component, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { SessionService } from '@app/core/services/session.service';
import { Dealer } from '@app/core/models/dealer.model';
import { HelperService } from '@app/core/services/helper.service';

@Component({
	selector: 'cng-order-summary',
	templateUrl: './order-summary.component.html',
	styleUrls: ['./order-summary.component.less'],
})
export class ConfigureOrderSummaryComponent {
	@Input() show_totals = false;
	@Input() force_cash_payment = false;

	dealer: Dealer = this.session_service.getDealer();

	vehicle = this.configure_service.configure_data.steps.purchase_vehicle.data;
	part_exchanges = this.configure_service.configure_data.steps.part_exchange.data;
	addons = this.configure_service.configure_data.steps.customise_review.data.addons;
	selected_addons = this.getSelectedAddons();

	handover: any = this.configure_service.configure_data.steps.delivery_options.data.handover;
	delivery_address: string = this.helper_service.buildAddress(
		this.configure_service.getDeliveryAddressAsArray(),
		false
	);
	collection_address: string = this.configure_service.getCollectionAddress() || this.dealer.address;

	finance_meta = this.configure_service.configure_data.meta.finance;

	grand_total: number = this.configure_service.configure_data.steps.customise_review.data.grand_total;
	grand_total_net: number = this.configure_service.configure_data.steps.customise_review.data.grand_total_net;
	grand_total_vat: number = this.configure_service.configure_data.steps.customise_review.data.grand_total_vat;

	destroyed$: Subject<boolean> = new Subject<boolean>();

	/**
	 * Constructs class and injects dependencies.
	 */
	constructor(
		private session_service: SessionService,
		public configure_service: ConfigureService,
		private helper_service: HelperService
	) {
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data: any) => {
			this.vehicle = configure_data.steps.purchase_vehicle.data;
			this.part_exchanges = configure_data.steps.part_exchange.data;
			this.addons = configure_data.steps.customise_review.data.addons;
			this.selected_addons = this.getSelectedAddons();

			this.handover = configure_data.steps.delivery_options.data.handover;
			this.delivery_address = this.helper_service.buildAddress(
				this.configure_service.getDeliveryAddressAsArray(),
				false
			);
			this.collection_address = this.configure_service.getCollectionAddress() || this.dealer.address;

			this.finance_meta = configure_data.meta.finance;

			this.grand_total = configure_data.steps.customise_review.data.grand_total;
			this.grand_total_net = configure_data.steps.customise_review.data.grand_total_net;
			this.grand_total_vat = configure_data.steps.customise_review.data.grand_total_vat;
		});
	}

	getSelectedAddons() {
		const selected_addons = [];

		this.addons.forEach((addon) => {
			addon.options.forEach((option) => {
				if (option.selected) {
					selected_addons.push({
						description:
							addon.description === option.description
								? addon.description
								: addon.description + ': ' + option.description,
						amount: option.vat && this.vehicle.add_vat ? option.net_amount : option.amount,
						vat: option.vat,
					});
				}
			});
		});

		return selected_addons;
	}

	/**
	 * Destroys component and any open subscriptions.
	 */
	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
